import axios from 'axios.js'

const unwrapData = (response) => response?.data?.data ?? response?.data ?? null

export const searchClients = async (query, limit = 20) => {
    const response = await axios.get('/api/reference/clients/search', {
        params: {
            query: String(query || '').trim(),
            limit: Math.min(Math.max(Number(limit) || 20, 1), 50),
        },
    })
    const data = unwrapData(response)
    const items = Array.isArray(data?.items) ? data.items : (Array.isArray(data) ? data : [])
    return items
}

export const getClientsPage = async ({
    page = 0,
    limit = 20,
    search = '',
    sortField = 'id',
    sortDirection = 'desc',
} = {}) => {
    const response = await axios.get('/api/reference/clients/page', {
        params: {
            page: Math.max(Number(page) || 0, 0),
            limit: Math.min(Math.max(Number(limit) || 20, 1), 100),
            search: String(search || '').trim(),
            sortField,
            sortDirection,
        },
    })
    const data = unwrapData(response) || {}
    return {
        items: Array.isArray(data.items) ? data.items : [],
        total: Math.max(Number(data.total) || 0, 0),
        page: Math.max(Number(data.page) || 0, 0),
        limit: Math.max(Number(data.limit) || Number(limit) || 20, 1),
    }
}

export const getClientInfo = async (idKlient) => {
    const response = await axios.post('/api/reference/getKlientInfo', {
        idKlient: Number(idKlient || 0),
    })
    return unwrapData(response) || {}
}

export const deleteClient = async (id) => {
    const response = await axios.post('/api/reference/setDeletedKlientDirectory', { id, val: true })
    return unwrapData(response)
}

export const updateClient = async (dataKlientDirectoryUpdate) => {
    const response = await axios.post('/api/reference/setUpdateKlientDirectory', { dataKlientDirectoryUpdate })
    return unwrapData(response)
}

export const createClient = async (dataKlientDirectoryUpdate) => {
    const response = await axios.post('/api/reference/setSaveNewKlientDirectory', { dataKlientDirectoryUpdate })
    return unwrapData(response)
}
